import * as path from 'node:path';

export function repoDisplayPath(repoPath: string, multiRepo: boolean): (rel: string) => string {
  const slug = path.basename(repoPath).replace(/[^\w.-]+/g, '_') || 'repo';
  return (rel: string) => (multiRepo ? `${slug}/${rel}` : rel);
}

export function safeRelPath(rel: string | undefined): boolean {
  return typeof rel === 'string' && rel.length > 0 && !rel.includes('..');
}

export function newUntrackedPaths(raw: string, baselineUntracked: readonly string[], seen: ReadonlySet<string>): string[] {
  const baseline = new Set(baselineUntracked);
  return raw
    .split('\n')
    .map((l) => l.trim())
    .filter((rel) => rel && !baseline.has(rel) && !seen.has(rel));
}
